import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ethereumApi } from '@yozh-io/1inch-widget-api-client';

import { ApproveApi } from '../../../api';
import { ApproveStatus } from '../../../types';

export const fetchApproveSpender = createAsyncThunk(
  'approve/getApproveSpenderInfo',
  async (chainId: number | undefined, { rejectWithValue }) => {
    try {
      const JSONApiResponse = await ApproveApi(chainId).chainApproveControllerGetSpenderRaw();
      return await JSONApiResponse.raw.json();
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateSingleAllowance = createAsyncThunk(
  'approve/updateAllowance',
  async (updater: () => Promise<string>) => {
    return await updater();
  }
);

export interface ApproveState {
  approveTransactionInfo: ethereumApi.ApproveCalldataResponseDto;
  spender: ethereumApi.ApproveSpenderResponseDto;
  allowance: string;
}

export const initialState: ApproveState = {
  approveTransactionInfo: {
    data: '',
    gasPrice: '',
    to: '',
    value: '',
  },
  spender: { address: '' },
  allowance: '',
};

const approveSlice = createSlice({
  name: 'approve',
  initialState,
  reducers: {},
  extraReducers: (tokens) => {
    tokens.addCase(fetchApproveSpender.fulfilled, (state, action) => {
      state.spender = action.payload;
    });
    tokens.addCase(updateSingleAllowance.fulfilled, (state, action) => {
      state.allowance = action.payload;
    });
    tokens.addCase(updateSingleAllowance.pending, (state) => {
      state.allowance = ApproveStatus.PENDING;
    });
  },
});

const { reducer } = approveSlice;

export default reducer;
